import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CalculateIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.889 7.111L7.111 16.889M8.889 10.667V7.111M7.111 8.889H10.667M13.333 15.111H16.889M8.267 20H15.733C17.227 20 17.974 20 18.544 19.709C19.046 19.454 19.454 19.046 19.709 18.544C20 17.974 20 17.227 20 15.733V8.267C20 6.773 20 6.026 19.709 5.456C19.454 4.954 19.046 4.546 18.544 4.291C17.974 4 17.227 4 15.733 4H8.267C6.773 4 6.026 4 5.456 4.291C4.954 4.546 4.546 4.954 4.291 5.456C4 6.026 4 6.773 4 8.267V15.733C4 17.227 4 17.974 4.291 18.544C4.546 19.046 4.954 19.454 5.456 19.709C6.026 20 6.773 20 8.267 20Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

CalculateIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(CalculateIcon);
